module.exports = __webpack_public_path__ + "974bca2bf26dc2fae8d67248d9df5e34.ttf";